import axios from 'utils/axios';
import type {
    ObjectDiscussionChannel,
    ObjectDiscussionListType,
    ObjectDiscussionMessageType,
    ObjectDiscussionUnreadType,
} from '@econtractor/types';

const discussionPath = (channel: ObjectDiscussionChannel, objectId: number): string => (
    channel === 'team'
        ? `/4team/object/${objectId}/discussion`
        : `/objects/${objectId}/discussion`
);

export const getObjectDiscussion = async (
    channel: ObjectDiscussionChannel,
    objectId: number,
): Promise<ObjectDiscussionListType | null> => {
    try {
        const response = await axios(discussionPath(channel, objectId));
        const data = response?.data;
        if (!data || !Array.isArray(data.messages)) return null;
        return {
            messages: data.messages,
            canWrite: Boolean(data.canWrite),
        };
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const getObjectDiscussionUnread = async (
    channel: ObjectDiscussionChannel,
    objectId: number,
): Promise<ObjectDiscussionUnreadType | null> => {
    try {
        const response = await axios(`${discussionPath(channel, objectId)}/unread`);
        const unreadCount = Number(response?.data?.unreadCount);
        if (!Number.isFinite(unreadCount)) return null;
        return { unreadCount };
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const addObjectDiscussionMessage = async (
    channel: ObjectDiscussionChannel,
    objectId: number,
    message: string,
): Promise<ObjectDiscussionMessageType | null> => {
    try {
        const response = await axios.post(discussionPath(channel, objectId), { message });
        return response?.data?.message || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const markObjectDiscussionRead = async (
    channel: ObjectDiscussionChannel,
    objectId: number,
    lastMessageId: number,
): Promise<boolean> => {
    try {
        const response = await axios.post(`${discussionPath(channel, objectId)}/read`, { lastMessageId });
        return response?.data?.stat === true;
    } catch (e) {
        console.error(e);
        return false;
    }
};
